import { z } from 'zod';

export const dipPostRequestSchema = z.object({});
